// Module
var code = "<div id=\"V-BAC3E2B1-B8BD-454B-A47E-C05977182647\" class=\"component-hr\"> </div> ";
// Exports
export default code;